<div class="route-results-header-container">
    <div class="first-row">
        <button mat-fab extended (click)="closeResults()" class="modify-search-button"
            [ngClass]="isMobile() ? 'modify-search-button-small' : ''">
            <mat-icon  fontIcon="arrow_back"></mat-icon>
            {{'routeResults.modifySearch' | transloco}}
        </button>
        <section class="date-section">
            <div class="time-row-item">
                <mat-icon>access_time</mat-icon>
                <span class="date-label">{{ routeFormResults()?.requestParameters?.time }}</span>
            </div>
            <div class="time-row-item">
                <mat-icon>event</mat-icon>
                <span class="date-label">{{ routeFormResults()?.requestParameters?.date }}</span>
            </div>
        </section>
    </div>
    <div class="direction-container" style="margin-top: 10px;">
        <span class="direction-title">{{'routeResults.originAndDestiny' | transloco }}</span>
        <div class="direction-description">
            <mat-icon svgIcon="aFrom"></mat-icon>
            <span class="direction-label">{{ routeFormResults()?.requestParameters?.fromDescription }}</span>
        </div>
    </div>
    <div class="direction-container">
        <div class="direction-description">
            <mat-icon svgIcon="bTo"></mat-icon>
            <span class="direction-label">{{ routeFormResults()?.requestParameters?.toDescription }}</span>
            <button (click)="shareButtonClicked()" mat-mini-fab class="share-button" aria-label="share route button"><mat-icon fontIcon="share"
                    color="primary"></mat-icon></button>
        </div>

    </div>